import DrumBand from './DrumBand'

function App() {
  return (
    <div className="App">
      <DrumBand />
    </div>
  );
}

export default App;
